<template>
  <div>
    <v-container class="white text-center">
      <v-row>
        <v-col cols="12" class="body-2 grey--text text-left pb-0">
          <div>
            <v-breadcrumbs
              :items="routeItems"
              divider=">"
              class="pb-0 pl-3"
            ></v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <v-row class="pa-2 pt-0">
        <v-col cols="12" class="headline pl-4">TRANSFERENCIAS</v-col>
      </v-row>
    </v-container>
    <v-container class="background-gray pt-0">
      <v-row justify="space-between" height="10">
        <v-col cols="6" sm="4" class="pt-0 pb-0 pl-0">
          <v-overflow-btn
            append-icon="arrow_drop_down"
            class="combo pa-0 caption"
            color="accent"
            v-model="filterBy"
            dense
            height="25"
            :items="[
              { text: 'Fecha-Asc', value: 'dateAsc' },
              { text: 'Fecha-Desc', value: 'dateDesc' },
              { text: 'Número-Asc', value: 'numAsc' },
              { text: 'Número-Desc', value: 'numDesc' }
            ]"
            @change="filterByParam(filterBy)"
          ></v-overflow-btn>
        </v-col>
      </v-row>
      <v-row wrap class="mt-2 pl-5 pr-5">
        <v-col
          cols="12"
          md="6"
          lg="4"
          class="pb-0"
          v-for="(pedido, index) in transfers"
          :key="index"
        >
          <v-card class="elevation-0" outlined>
            <v-container class="pa-0 pl-2 pr-2">
              <v-row align="center">
                <v-col cols="7" class="pt-1 pb-1">
                  <span class="body-2 font-weight-regular"
                    >Nº Pedido: {{ pedido.id }}</span
                  >

                  <br />
                  <div class="caption font-weight-light fix-marign-middle">
                    Fecha Inicio:{{ pedido.date | compactDate }}
                  </div>
                  <br />
                  <div
                    :class="statusClass(pedido.status)"
                    class="font-weight-light fix-marign"
                  >
                    Realizar Checklist
                  </div>
                </v-col>
                <v-col cols="5" class="text-right" justify="center">
                  <v-btn
                    class="black--text"
                    small
                    block
                    color="accent"
                    @click="
                      $router.push({
                        name: 'transfer-detail',
                        params: { id: pedido.key }
                      })
                    "
                    >Ver Detalles</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col v-if="!pedidos.length" cols="12" class="text-center"
          >No se han encontrado pedidos en esa categoría</v-col
        >
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { shortDateStringFilter } from "@/filters";
export default {
  data() {
    return {
      filterBy: { text: "Fecha - Asc", value: "dateAsc" },
      transfers: []
    };
  },
  beforeMount() {
    this.getAccesSections(this.userAccess);
    this.getTransfers(null).then(transfers => {
      this.transfers.push(...transfers);
    });
  },
  created() {
    // :: Create a listener when the user scroll the page down
    // :: to call the next orders in list.
    window.addEventListener("scroll", this.lazyLoad);
  },
  destroyed() {
    // :: Destroy the listener when the user scroll the page down
    // :: to deactivate this listener in other views.
    window.removeEventListener("scroll", this.lazyLoad);
  },
  computed: {
    ...mapState("dashboard", ["menuOrderTypeArray"]),
    ...mapState("user", ["userAccess"]),
    ...mapState("orders", ["pedidos", "totalResults", "lastDocumentTransfer"]),
    routeItems() {
      let routeItems = [];
      let path = "";
      this.$router.currentRoute.fullPath.split("/").forEach(element => {
        path += element + "/";
        routeItems.push({
          text:
            element.length > 0
              ? element.charAt(0).toUpperCase() + element.substring(1)
              : "Inicio",
          disabled: false,
          href: path
        });
        if (routeItems[routeItems.length - 1].text === "Inicio")
          routeItems.splice(-1, 1);
      });
      return routeItems;
    }
  },
  methods: {
    ...mapActions("dashboard", ["getAccesSections"]),
    ...mapActions("transfers", ["getTransfers"]),
    statusClass(status) {
      let color = status == "pickup" ? "orange" : "red";
      return "caption " + color + "--text";
    },
    filterByParam(filter) {
      switch (filter) {
        case "dateAsc":
          this.filterData("date", "ASC");
          break;
        case "dateDesc":
          this.filterData("date");
          break;
        case "numAsc":
          this.filterData("id", "ASC");
          break;
        case "numDesc":
          this.filterData("id");
          break;
        default:
          break;
      }
    },
    async lazyLoad() {
      // :: Create a variable to know when the scroll position is at the bottom of the page.
      const scrollIsAtTheBottom =
        Math.abs(
          document.documentElement.scrollHeight -
            window.innerHeight -
            window.scrollY
        ) <= 1;

      if (scrollIsAtTheBottom) {
        this.getTransfers(this.lastDocumentTransfer).then(transfers => {
          this.transfers.push(...transfers);
        });
      }
    },
    filterData(key, type) {
      if (type === "ASC") {
        this.transfers.sort(function(a, b) {
          if (a[key] < b[key]) {
            return 1;
          }
          if (a[key] > b[key]) {
            return -1;
          }
          return 0;
        });
      } else {
        this.transfers.sort(function(a, b) {
          if (a[key] > b[key]) {
            return 1;
          }
          if (a[key] < b[key]) {
            return -1;
          }
          return 0;
        });
      }
    }
  },
  filters: {
    compactDate: shortDateStringFilter
  }
};
</script>
<style>
.combo {
  font-weight: 400;
}
.caption {
  font-weight: 300;
}
.combo i.v-icon.notranslate.material-icons.theme--light {
  color: #ffcd00 !important;
}
.fix-marign {
  margin-top: -27px !important;
}
.fix-marign-middle {
  margin-top: -3px !important;
}

/* Style Overflow buttons */
.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: unset;
}
.v-overflow-btn .v-input__control::before {
  height: 0px;
}
.v-overflow-btn .v-select__selection--comma:first-child {
  margin-left: 6px;
}
</style>
